
//统一域名地址
const domain = process.env.NODE_ENV === 'production'
    ? window.location.protocol + '//' + window.location.host
    : 'https://www.yixingauto.com';

//项目配置
const _config = {

    //项目路由前缀
    prefix: 'yx_page',
    //提交接口
    domain: domain,

}

export default _config
